import React from 'react'
import { Input } from '@h4b-dev/components'
import { useTranslation } from '@hooks/I18nProvider'
import { css } from 'linaria'

const styles = css`
  @apply max-w-max text-gray-900 text-xs;
  
  .container-input > div {
    @apply rounded rounded-sm border-none;
    box-shadow: none;
  }

  .select__control {
    @apply bg-transparent;
    min-height: 20px;
    box-shadow: none;
  }

  .select__input {
    height: 10px;
  }

  .select__indicator {
    @apply p-0 pr-2 text-gray-400;

    svg {
      @apply fill-current;
      width: 15px;
      height: 15px;
    }
  }

  .select__value-container {
    @apply py-1;

    &:last-child {
      @apply m-0 p-0;
    }
  }

  .select__single-value {
    @apply min-w-max transform translate-y-0;
    position: initial;
  }

  .select__indicator-separator {
    @apply hidden;
  }

  .select__menu {
    .select__option {
      @apply bg-white text-gray-500;

      &--is-selected,
      &--is-selected.select__option--is-focused {
        @apply bg-gray-300 text-gray-800;
      }

      &--is-focused {
        @apply bg-white text-gray-500;
      }
    }
  }
`

const opts = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Español',
    value: 'es',
  },
]

const LanguageSelector = () => {
  const { lang: { locale }, switchLang } = useTranslation()
  return (
    <div className={styles}>
      <Input
        type="select"
        options={opts}
        onChange={({ target }) => switchLang(target.value)}
        selectProps={{
          defaultValue: opts.find(({ value }) => value === locale),
          value: opts.find(({ value }) => value === locale),
          isSearchable: false,
          isClearable: false,
        }}
      />
    </div>
  )
}

export default LanguageSelector
